<template>
  <div :class="{ 'highlight' : highlight }">
    <slot name="header"/>
    <slot name="subheader"/>
    <div class="sc-comparison-table-column-rows">
      <slot name="row"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScComparisonTableColumnComponent',
  props: {
    highlight: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style scoped lang="scss">
.sc-comparison-table-column-rows > :nth-child(odd) {
  background: $sc-comparisontable-odd-row-bg;
}

.highlight {
  border: 1px solid $sc-comparisontable-highlighted-column-border;
  box-shadow: 0 0 5px 3px $sc-comparisontable-highlighted-column-border-shadow;
  z-index: 1;
}
</style>
